"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubscriptionPurchasedEvent = exports.isSegmentUserTrackEvent = exports.SegmentUserTrackEventSchema = exports.isSegmentUserEvent = exports.isSegmentTrackEvent = exports.isSegmentIdentifyEvent = exports.isSegmentEvent = exports.SegmentEventTypeSchema = void 0;
/**
 * WARNING!!!
 * Changes to all these schemas should be backwards compatible, as
 * there's other systems (e.g.: Receipt Emailer, Achievements System) depending on them.
 *
 * If you need to, you can look at https://github.com/segmentio/analytics-next
 * to derive/verify types.
 */
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
exports.SegmentEventTypeSchema = zod_1.z.union([
    zod_1.z.literal("track"),
    zod_1.z.literal("page"),
    zod_1.z.literal("identify"),
    zod_1.z.literal("group"),
    zod_1.z.literal("alias"),
    zod_1.z.literal("screen"),
]);
const SegmentEventSchema = zod_1.z.object({
    _metadata: zod_1.z.record(zod_1.z.unknown()).optional(),
    context: zod_1.z.record(zod_1.z.unknown()).optional(),
    event: zod_1.z.string().optional(),
    integrations: zod_1.z.record(zod_1.z.unknown()).optional(),
    messageId: zod_1.z.string(),
    originalTimestamp: zod_1.z.string(),
    // Should this be optional?
    projectId: zod_1.z.string(),
    properties: zod_1.z.record(zod_1.z.unknown()).optional(),
    receivedAt: zod_1.z.string(),
    sentAt: zod_1.z.string(),
    timestamp: zod_1.z.string(),
    traits: zod_1.z.record(zod_1.z.unknown()).optional(),
    type: exports.SegmentEventTypeSchema,
    userId: zod_1.z.string().optional(),
    // Should this be optional?
    version: zod_1.z.number(),
    writeKey: zod_1.z.string(),
});
exports.isSegmentEvent = type_validation_helpers_1.getTypeValidationFunction(SegmentEventSchema);
const SegmentIdentifyEventSchema = SegmentEventSchema.extend({
    type: zod_1.z.literal("identify"),
});
exports.isSegmentIdentifyEvent = type_validation_helpers_1.getTypeValidationFunction(SegmentIdentifyEventSchema);
const SegmentTrackEventSchema = SegmentEventSchema.extend({
    event: zod_1.z.string(),
    type: zod_1.z.literal("track"),
});
exports.isSegmentTrackEvent = type_validation_helpers_1.getTypeValidationFunction(SegmentTrackEventSchema);
const SegmentUserEventSchema = SegmentEventSchema.extend({
    userId: zod_1.z.string(),
});
exports.isSegmentUserEvent = type_validation_helpers_1.getTypeValidationFunction(SegmentUserEventSchema);
exports.SegmentUserTrackEventSchema = SegmentTrackEventSchema.extend({
    userId: zod_1.z.string(),
});
exports.isSegmentUserTrackEvent = type_validation_helpers_1.getTypeValidationFunction(exports.SegmentUserTrackEventSchema);
const SubscriptionPurchasedPropertiesSchema = zod_1.z.object({
    coupon: zod_1.z.string().optional(),
    email: zod_1.z.string(),
    hasTrial: zod_1.z.boolean(),
    invoiceDate: zod_1.z.string(),
    nextBillingAmount: zod_1.z.number().optional(),
    nextBillingOn: zod_1.z.string(),
    paymentAmount: zod_1.z.number(),
    planPrice: zod_1.z.number(),
    purchasedAtDate: zod_1.z.string(),
    subscriptionPlan: zod_1.z.string(),
    trialExpirationDate: zod_1.z.string().optional(),
    trialStartDate: zod_1.z.string().optional(),
    workflow: zod_1.z.string().optional(),
});
const SubscriptionPurchasedEventSchema = SegmentTrackEventSchema.extend({
    properties: SubscriptionPurchasedPropertiesSchema,
    userId: zod_1.z.string(),
});
exports.isSubscriptionPurchasedEvent = type_validation_helpers_1.getTypeValidationFunction(SubscriptionPurchasedEventSchema);
//# sourceMappingURL=segment_types.js.map